<template>
    <div class="breadcrumbs">
        <ul class="breadcrumb text-xs text-base-content-subtle breadcrumbs pt-0 pb-0">
            <li>
                <MiscLink to="/customer">
                    {{ $t('customer.breadcrumb.customer') }}
                </MiscLink>
            </li>
            <li class="font-semibold">
                {{ props.currentPage }}
            </li>
        </ul>
    </div>
</template>

<script setup lang="ts">
const props = defineProps<{
    currentPage: string
}>()
</script>
